import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import { ApiPaths } from 'src/enums/api-paths';
import { ConfigService } from '../config.service';
import { IdentityService } from '../identity/identity.service';
import { ErrorService } from './errors.service';

@Injectable({
  providedIn: 'root'
})
export class ValidatorService {
  identityTypeMap = new Map([
    [1, 'CITIZEN'],
    [2, 'COMPANY'],
    [3, 'CITIZEN_PROFESSIONAL'],
    [4, 'COMPANY_PROFESSIONAL'],
  ]);

  mappingSerializationFieldCompileDraft = new Map ([
    ['birthDate', 'personalData'],
    ['birthCountry', 'personalData'],
    ['birthProvince', 'personalData'],
    ['birthCity', 'personalData'],
    ['fiscalCodeCardId', 'personalData'],
    ['fiscalCodeCardExpirationDate', 'personalData'],

    ['country', 'residence'],
    ['province', 'residence'],
    ['city', 'residence'],
    ['addressType', 'residence'],
    ['zipCode', 'residence'],

    ['idDocumentType', 'identityDocument'],
    ['idDocumentNumber', 'identityDocument'],
    ['idDocumentExpirationDate', 'identityDocument'],
    ['idDocumentIssueDate', 'identityDocument'],
    ['idDocumentIssuerName', 'identityDocument'],
    ['idDocumentNumber', 'identityDocument'],

    ['phone', 'contact'],
  ]);


  constructor(
    private http: HttpClient,
    private errorService: ErrorService,
  ) { }

  getErrorFromSerializationField(field: AbstractControl, defaultMessage: string = ''): string {
    const errors = field.errors;
    if (!errors) {
      return defaultMessage;
    }
    const errorMessage: string = errors?.error;
    return errorMessage ? errorMessage : defaultMessage;
  }

  emailValidator(): AsyncValidatorFn {
    return (ctrl: AbstractControl): Observable<{ [key: string]: any; } | null> => {
      return this.http.post(
        `${ConfigService.settings.baseUrlNoApi}/${ApiPaths.CheckEmail}`,
        { email: ctrl.value, req_type: this.identityTypeMap.get(4) }
      ).pipe(
        filter(Boolean),
        debounceTime(700),
        distinctUntilChanged(),
        map((data: { [key: string]: any; }) => data.esito.toLowerCase() === 'ok' ? null : { errorCode: data.result.error_code })
      );
    };
  }
}
